/**
 * @namespace app.api.dashboards
 */
import IService from '../IService';

export default IService.extend({
  initialize: function () {
    this.$ajax = null;
    this.cache = new Map();
  },

  abort: function () {
    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
    }
  },

  get: function (options) {
    options = $.extend(
      {
        id: 'me',
        enableCache: true,
        CACHE_TIMEOUT: app.TIME.HOUR,
      },
      options
    );

    let cacheDashboard;

    const deferred = new $.Deferred();

    if (options.enableCache && this.cache.has(options.id)) {
      cacheDashboard = this.cache.get(options.id);

      if (cacheDashboard) {
        if (cacheDashboard.url && cacheDashboard.timeout > Date.now()) {
          deferred.resolve({
            status: 200,
            url: cacheDashboard.url,
          });

          return deferred.promise();
        }
      }
    }

    this.$ajax = $.ajax({
      url: app.apiUrl(`/api/v1/dashboards/${options.id}`),

      type: 'GET',

      error: function (err) {
        deferred.reject({
          status: err.status,
          statusText: err.statusText,
        });
      },

      dataType: 'json',

      timeout: app.TIME.MINUTE,

      success: (response) => {
        if (_.isDefined(response.dashboardUrl)) {
          const dashboardUrl = response.dashboardUrl;

          if (options.enableCache) {
            this.cache.set(options.id, {
              url: dashboardUrl,
              timeout: Date.now() + options.CACHE_TIMEOUT,
            });
          }

          deferred.resolve({
            status: 200,
            url: dashboardUrl,
          });
        } else {
          // errors should be handled in error(), but
          // if by any chance, success is invoked without dashboardUrl,
          // then handle it like it's 500 error
          deferred.reject({ status: 500 });
        }
      },
    }).always(() => {
      this.$ajax = null;
    });

    return deferred.promise();
  },
});
